import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"

import Image from "components/landing/image"

const FeaturingDiamond = ({ data }) => (
  <Box contain mb={4}>
    <Image image={data.valueFactors} />
    <Image image={data.features} />
  </Box>
)

FeaturingDiamond.propTypes = {
  data: PropTypes.object,
}
export default FeaturingDiamond
